(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eyf-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__eyfDrawer) return;
    window.__eyfDrawer = true;
    const CTA = { 'shop-by-scripture': 'Shop every design', clothing: 'Shop all clothing', 'faith-resources': 'Visit the Knowledge Base', about: 'Read our story' };

    const enhance = () => {
      document.querySelectorAll('.header-drawer .menu-drawer__menu--grandchildlist .menu-drawer__menu-item-text').forEach((el) => {
        if (el.dataset.eyfd || !el.textContent.includes(' · ')) return;
        const [ref, ...rest] = el.textContent.trim().split(' · ');
        el.dataset.eyfd = '1';
        el.classList.add('eyfd-verse');
        el.textContent = '';
        const r = document.createElement('span'); r.className = 'eyfd-ref'; r.textContent = ref;
        const n = document.createElement('span'); n.className = 'eyfd-name'; n.textContent = rest.join(' · ');
        el.append(r, n);
      });
      document.querySelectorAll('.header-drawer .menu-drawer__submenu').forEach((sub) => {
        const list = sub.querySelector('.menu-drawer__menu--childlist');
        const title = sub.querySelector('.menu-drawer__title');
        if (!list || !title || sub.querySelector('.eyfd-all')) return;
        const key = (sub.id || '').replace(/^link-/, '');
        const a = document.createElement('a');
        a.className = 'eyfd-all';
        a.href = title.getAttribute('href');
        a.textContent = CTA[key] || 'Shop all';
        const arrow = document.createElement('span'); arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '→';
        a.append(arrow);
        list.after(a);
      });
    };

    /* One group open at a time; opening a submenu shows its first group already open */
    document.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.open || !d.closest('.header-drawer')) return;
      if (d.classList.contains('menu-drawer__menu-container')) {
        enhance();
        const groups = d.querySelectorAll('.menu-drawer__submenu .menu-drawer__menu--childlist details');
        if (groups.length && ![...groups].some((g) => g.open)) groups[0].open = true;
        return;
      }
      const list = d.closest('.menu-drawer__menu--childlist');
      if (!list) return;
      list.querySelectorAll('details').forEach((o) => { if (o !== d && o.open && !o.contains(d)) o.open = false; });
    }, true);

    /* Phone menu row (Shop by Scripture, Clothing, ...): items with sub-menus open the drawer
       straight to that section instead of jumping to the all-products page */
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.menu-list--mobile a.menu-list__item[id^="MenuItem-"]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
      const handle = link.id.slice('MenuItem-'.length);
      const drawer = document.querySelector('.header__drawer .header-drawer') || document.querySelector('.header-drawer');
      if (!drawer) return;
      const section = drawer.querySelector('summary#HeaderDrawer-' + CSS.escape(handle));
      if (!section || !section.closest('details.menu-drawer__menu-container')) return;
      e.preventDefault();
      const container = drawer.querySelector('details.menu-drawer-container');
      const toggle = container && container.querySelector(':scope > summary');
      const openSection = () => { enhance(); section.click(); };
      if (container && !container.open && toggle) {
        toggle.click();
        setTimeout(openSection, 120);
      } else {
        openSection();
      }
    }, true);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance); else enhance();
  })();
  } catch(e) { console.error(e); }
})();

})();
